// extracted by mini-css-extract-plugin
export default {"inputField":"contextual-menu-inputs-option-module__inputField--PWfZB"};